<template>
    <footer class="wise cc-footer-wise-container">
        <div class="cc-footer-wise-content">
            <div class="cc-footer-wise-left">
                <div class="cc-footer-wise-logo">
                    <img src="../../../assets/logo.png" alt="">
                </div>
                <div class="cc-footer-wise-contact">
                    <h4>联系我们</h4>
                    <div>
                        <label class="tip">邮箱：</label>
                        <a class="link">sy-aigc-cy@baidu.com</a>
                    </div>
                </div>
            </div>
            <div class="cc-footer-wise-right">
                <img alt="" src="../assets/indexQrcode.png">
            </div>
        </div>
        <div class="cc-footer-wise-copyright">
            &copy; All right reserved
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.baidu.com/duty"
            >使用百度前必读</a>
        </div>

    </footer>
</template>

<script>
export default {
    name: 'cc-footer',
    inject: ['$toast'],
    components: {
    },
    data() {
        return {
        };
    },
    methods: {
    }
};

</script>

<style lang="less" scoped>
.cc-footer-wise {
    &-container {
        background: #F6F7FA;
        position: relative;
        margin: 0 auto;
    }
    &-content {
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 2.4rem 2rem 2rem;
    }
    &-logo {
        height: 2rem;
        width: auto;
        img {
            height: 100%;
        }
    }
    &-contact {
        margin-top: 1.8rem;
        font-size: 1.4rem;
        line-height: 2rem;
        color: @dls-color-gray-7;
        h4 {
            margin-bottom: 0.7rem;
            font-weight: 400;
        }
        a {
            color: @dls-color-gray-7;
        }
    }
    &-right {
        height: 8.9rem;
        img {
            height: 100%;
        }
    }
    &-copyright {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #848B99;
        width: 100%;
        border-top: 1px solid #E2E6F0;
        text-align: center;
        padding-top: 2rem;
        padding-bottom: 2.2rem;
        margin: 0 auto;
        a {
            color: #848B99;
            margin-left: 0.5rem;
        }
    }
}
</style>